import { ajaxIcon, switchOffIconSpinner } from "../../Utils/Ajax/ajax";
import { errorToast, successToast } from "../../Utils/utils";

export function changeTestSetting(abId, setting, newValue, button){
    const config = {
        url: '/test/' + abId + '/update',
        data: {
            // 'action': 'change_ab_setting', //calls wp_ajax_nopriv_ajaxlogin
            // 'abId': abId,
            'setting': setting,
            'newSettingValue': newValue,
        }, // noch ersetzten durch pexam_ajax_object
        success: function(data){
            switchOffIconSpinner(button);
            changeTestSettingsButton(newValue, button);
            successToast('', 'Erfolg' , 4500);
        }, 
        error: function(data){
            errorToast('Aktion fehlgeschlagen', data.message, 7500);
        }
    }
    ajaxIcon(config, button);

}


function changeTestSettingsButton(newValue, button){
    const posClasses = 'text-success btn-light-success';
    const negClasses = 'text-danger btn-light-danger';
    if (newValue === Number(1)){
        button.addClass(posClasses).removeClass(negClasses);
    } else {
        button.addClass(negClasses).removeClass(posClasses);
    }
}